import { useMutation } from "@tanstack/react-query";
import { sendFeedback } from "./feedback-axios";
export function useSendFeedback() {
    return useMutation({
        mutationFn: sendFeedback,
    });
}
